import {addClass, hasClass} from 'uikit-util';

export default {

    connected() {
        !hasClass(this.$el, this.$name) && addClass(this.$el, this.$name);
    }

};



//////////////////
// WEBPACK FOOTER
// ./public/themes/frontend/cinquanta3/node_modules/uikit/src/js/mixin/class.js
// module id = null
// module chunks = 